<template>
  <div>
    <el-card shadow="never" style="border: 0" class="mt20">
      <div slot="header" class="clearfix">
        <span>{{ getUserRankText() }}</span>
        <el-select clearable class="ml20" v-model="userType" :placeholder="getPleaseSelectText()">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          v-model="nickeName"
          class="w220 ml20 mr20"
          :placeholder="getUserNamePlaceholder()"
        ></el-input>
        <el-button @click='userRank'>{{ getSearchText() }}</el-button>
      </div>
      <commonTable
        :tableData="tableData"
        :loading="loading"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange='handleCurrentChange'
        :currentPage="currentPage"
        :total="total"
      >
        <template v-slot:table>
          <el-table-column
            align="center"
            type="index"
            :label="getRankText()"
            show-overflow-tooltip
          />
          <el-table-column
            prop="name"
            align="center"
            :label="getDistributorNameText()"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.name ? scope.row.name : scope.row.nickeName }}
            </template>
          </el-table-column>
          <el-table-column
            prop="commissionRate"
            align="center"
            :label="getContactText()"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.bcPhone ? scope.row.bcPhone : scope.row.phone }}
            </template>
          </el-table-column>
          <el-table-column
            prop="sumBalance"
            align="center"
            :label="getTotalCommissionText()"
            show-overflow-tooltip
          />
          <el-table-column
            prop="sharesNum"
            align="center"
            :label="getSharesNumText()"
            show-overflow-tooltip
          />
          <el-table-column
            prop="buyerNum"
            align="center"
            :label="getPurchaseCountText()"
            show-overflow-tooltip
          />
          <el-table-column
            prop="completeTime"
            align="center"
            :label="getPurchaseRateText()"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{
                scope.row.sharesNum == 0
                  ? 0
                  : (scope.row.buyerNum / scope.row.sharesNum).toFixed(2)
              }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            :label="getUserTypeText()"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.userType == 1 ? getEmployeeText() : getNormalUserText() }}
            </template>
          </el-table-column>
        </template>
      </commonTable>
    </el-card>
  </div>
</template>

<script>
import { userRank } from "@/api/distribution";
import commonTable from "@/components/common/commonTable";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  data() {
    return {
      options: [
        { value: 1, label: this.getEmployeeText() },
        { value: 2, label: this.getNormalUserText() },
      ],
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      pageSize2: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      userType: "",
      nickeName: "",
    };
  },
  components: {
    commonTable,
  },
  created() {
    this.userRank();
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.updateOptions();
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    /**@method 查询分销用户 */
    async userRank() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        nickeName: this.nickeName,
        userType: this.userType,
      };
      try {
        this.loading = true;
        const result = await userRank(data);
        this.loading = false;
        const {
          pageInfo: { total, list },
        } = result?.data;
        this.tableData = list;
        this.total = total;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.userRank();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.userRank();
    },
    
    // 更新选项的语言
    updateOptions() {
      this.options = [
        { value: 1, label: this.getEmployeeText() },
        { value: 2, label: this.getNormalUserText() },
      ];
    },
    
    // 多语言方法
    getCurrentLanguage() {
      let currentLanguage = this.$store.state.currentLanguage;
      if (!currentLanguage) {
        currentLanguage = localStorage.getItem('language') || 'zh-TW';
      }
      return currentLanguage;
    },
    
    getUserRankText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '分销用户排名',
        'zh-TW': '分銷用戶排名',
        'en': 'Distribution User Ranking'
      };
      return textMap[currentLanguage] || '分销用户排名';
    },
    
    getPleaseSelectText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '请选择',
        'zh-TW': '請選擇',
        'en': 'Please select'
      };
      return textMap[currentLanguage] || '请选择';
    },
    
    getUserNamePlaceholder() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '请输入用户名称',
        'zh-TW': '請輸入用戶名稱',
        'en': 'Please enter user name'
      };
      return textMap[currentLanguage] || '请输入用户名称';
    },
    
    getSearchText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '搜索',
        'zh-TW': '搜索',
        'en': 'Search'
      };
      return textMap[currentLanguage] || '搜索';
    },
    
    getRankText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '排名',
        'zh-TW': '排名',
        'en': 'Rank'
      };
      return textMap[currentLanguage] || '排名';
    },
    
    getDistributorNameText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '分销者名称',
        'zh-TW': '分銷者名稱',
        'en': 'Distributor Name'
      };
      return textMap[currentLanguage] || '分销者名称';
    },
    
    getContactText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '联系方式',
        'zh-TW': '聯繫方式',
        'en': 'Contact'
      };
      return textMap[currentLanguage] || '联系方式';
    },
    
    getTotalCommissionText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '总佣金',
        'zh-TW': '總佣金',
        'en': 'Total Commission'
      };
      return textMap[currentLanguage] || '总佣金';
    },
    
    getSharesNumText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '分享次数',
        'zh-TW': '分享次數',
        'en': 'Share Count'
      };
      return textMap[currentLanguage] || '分享次数';
    },
    
    getPurchaseCountText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '购买次数',
        'zh-TW': '購買次數',
        'en': 'Purchase Count'
      };
      return textMap[currentLanguage] || '购买次数';
    },
    
    getPurchaseRateText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '购买率',
        'zh-TW': '購買率',
        'en': 'Purchase Rate'
      };
      return textMap[currentLanguage] || '购买率';
    },
    
    getUserTypeText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '用户属性',
        'zh-TW': '用戶屬性',
        'en': 'User Type'
      };
      return textMap[currentLanguage] || '用户属性';
    },
    
    getEmployeeText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '员工',
        'zh-TW': '員工',
        'en': 'Employee'
      };
      return textMap[currentLanguage] || '员工';
    },
    
    getNormalUserText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '普通用户',
        'zh-TW': '普通用戶',
        'en': 'Normal User'
      };
      return textMap[currentLanguage] || '普通用户';
    },
  },
};
</script>

<style lang="scss" scoped>
</style>